import { Component, ViewEncapsulation, Input, Output, EventEmitter, Renderer2, ChangeDetectorRef, NgZone } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { v_QuoteInvoiceBus } from '@app/cp/shared/models/v_QuoteInvoiceBus';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { QuoteService } from '@app/cp/shared/services/quote.service';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { QuoteInvoiceBus } from '@app/cp/shared/models/QuoteInvoiceBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { BaseGridEditInvLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-invlines.component';
import { QuoteBus } from '@app/cp/shared/models/QuoteBus';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { Subscription, fromEvent, Subject } from 'rxjs';
import { tap, take, takeUntil } from 'rxjs/operators';
import { CommonValues } from '../../shared/static/CommonValues';
import * as _ from 'lodash';
import { InvoiceMessageInfo } from '../../shared/models/InvoiceMessageInfo';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CustomerService } from '@app/cp/shared/services/customer.service';
import { LineItemPricingRangeBus } from '@app/cp/shared/models/LineItemPricingRangeBus';
import { CommonParam } from '../../shared/models/CommonParam';
import { InventorySuppliersBus } from '../../shared/models/InventorySuppliersBus';
import { InventoryLocationXrefBus } from '../../shared/models/InventoryLocationXrefBus';
import { VendorService } from '../../shared/services/vendor.service';
import { v_InventoryBus } from '../../shared/models/v_InventoryBus';

const matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

@Component({
    selector: 'quote-lineitems',
    templateUrl: './quote-lineitems.component.html',
    styleUrls: ['./quote-lineitems.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class QuoteLineItemsComponent extends BaseGridEditInvLinesComponent<v_QuoteInvoiceBus, null, QuoteService, QuoteBus> {
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    private destroy$ = new Subject();
    private currentSubscription: Subscription;
    inventoryLocationFC: MSFilterClass = new MSFilterClass("inventoryLocationId");
    partTypeFC: MSFilterClass = new MSFilterClass("supplierPartTypeMarkUpId");
    _vendorService: VendorService;
    supplierPartTypeMarkUp: any[] = [];
    supplierId_Zuggit: string = CommonValues.Supplier_Zuggit;

    @Output() showDispatch: EventEmitter<any> = new EventEmitter<any>();
    //for alerting the parent component to the grid having any items populated
    @Output() gridDataPopulateEvent: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowDispatchPopup: boolean = false;
    @Input() custLocPricingRanges: LineItemPricingRangeBus[] = [];
    @Input() canEditQuote: boolean;
    private insertMode: boolean = false;
    @Output() dropEvent: EventEmitter<any> = new EventEmitter<any>();
    svc_cust: any;
    rowLine: number;
    public featureFlagSet: any = {};

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: QuoteService, svc_cust: CustomerService, svc_inv: InventoryService, svc_dqoi: DQOIService, private zone: NgZone, featureFlagService: FeatureFlagService, vendorService: VendorService) {
        super(globals, renderer, cd, svc_inv, svc_dqoi, featureFlagService);
        this.svc_data = svc_data;
        this.svc_cust = svc_cust;
        this._vendorService = vendorService;

        this.className = "v_QuoteInvoiceBus";
        this.appCode = "QuoteInvoiceLines";
        this.processingHotKey = true;
        this.featureFlagService.featureFlagSets.subscribe(data => {
            this.featureFlagSet = data;
        });
        this.setSupplier(CommonValues.Supplier_Zuggit);
    }

    cancelHandler() {
        super.cancelHandler();
        if(this.featureFlagSet["ui-enable-lineitems-required-for-quote-save"]) {
            this.gridDataPopulateEvent.emit(this.hasGridData);
        }
    }

    createNewParent(data: QuoteBus): any {
        return new QuoteBus(data);
    }
    test() {
        console.log("qli-test-a: ", this.parentObj, this);

        //this.cd.detectChanges();
       // this.sumGrid();

    }

    afterSetInventoryLineAfterSetForm() {
        if (this.featureFlagSet['add-parts-on-hand-qty-in-quotes-and-orders']) {
            if (this.selectedData.isPart) {
                this.svc_inv.getLocationQuantityAndAll(this.selectedData.inventoryBillingCodeId, this.parentObj.locationId).subscribe((data: any) => {
                    if (data) {
                        this.setQuantityInStockDetailAll(data);
                        this.selectedData.allQuantity = data.allQuantity;
                        this.selectedData.locationQuantity = data.localQuantity;
                    }
                });
            }
        }
        if(this.featureFlagSet["ui-enable-lineitems-required-for-quote-save"]) {
            //if this method fires then an item has been added to the grid, always emit true
            this.gridDataPopulateEvent.emit(true);
        }
    }
    cellClickHandler(event) {
        if (this.canEditQuote) {
            super.cellClickHandler(event);
        } else {
            return false;
        }
    }
    override setInventorySearchData(value: any) {
        let param: CommonParam = new CommonParam();

        param.customerId = this.parentObj.customerId;
        param.locationId = this.parentObj.locationId;
        param.addParam("InventoryBillingCodeId", value.InventoryId);
        param.addParam("AccountClassId", this.parentObj.accountClassId);
        param.addParam("PersonId", this.selectedData.personId);
        param.addParam("TaxCodeId", CommonFunctions.hasValue(this.taxCode) ? this.taxCode.taxCodeId : null);
        param.addParam("bcUsePricing", false);
        param.addParam("FromQuote", true);

        this.setInventoryLine(param);
    }
    createForm() {
        this.editForm = new UntypedFormGroup({
            'quoteInvoiceId': new UntypedFormControl(),
            'quoteId': new UntypedFormControl(),
            'sortOrder': new UntypedFormControl(),
            'quantity': new UntypedFormControl(), //Qty
            'cost': new UntypedFormControl(), //Cost
            'markup': new UntypedFormControl(), //Markup
            'markupPercent': new UntypedFormControl(),
            'price': new UntypedFormControl(), //Price
            'isTaxable': new UntypedFormControl(), //Tax
            'isPrintable': new UntypedFormControl(), //Print
            'quoteInvoiceDesc': new UntypedFormControl(), //Summary
            'inventoryNumber': new UntypedFormControl(), //Item
            'isPart': new UntypedFormControl(),
            'hourlyRate': new UntypedFormControl(),
            'overheadRate': new UntypedFormControl(),
            'overheadPercent': new UntypedFormControl(),
            'amount': new UntypedFormControl(), //Amount
            'markupCost': new UntypedFormControl(), //MU Cost
            'fullDescription': new UntypedFormControl(), //Full Description
            'tax': new UntypedFormControl(), //Tax
            'inventoryBillingCodeId': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl(),
            'billingTypeId': new UntypedFormControl(),
            'personId': new UntypedFormControl(), //Resource
            'resource': new UntypedFormControl(),
            'warehouse': new UntypedFormControl(),
            'totalCost': new UntypedFormControl(),
            'isLabor': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl() ,
            'avalaraTaxCalculated': new UntypedFormControl(),
            'locationQuantity': new UntypedFormControl(),
            'allQuantity': new UntypedFormControl(),
            'supplierPrice': new UntypedFormControl(),
            'supplierAmount': new UntypedFormControl(),
            'supplierPartTypeMarkUpId': new UntypedFormControl(),
            'supplierPartTypeMarkUpString': new UntypedFormControl(),

        });
    }

    findPricingRangeMarkup(cost: number) :number {
        let range = this.custLocPricingRanges.find(e => e.low <= cost && e.high >= cost);

        if (range) {
            return range.markup;
        } else {
            return 0;
        }
    }
    setInventoryLine(param: CommonParam) {
        this.inventorySearching = true;
        this.svc_dqoi.getInventoryLine(param).subscribe(
            {
                next:
                    (info: InvoiceMessageInfo) => {
                        this.selectedData.setInventoryLine(info.primaryReturn);
                        if (info.getEmpRate === true && this.hasEditForm) {
                            this.selectedData.fullDescription = this.editForm.value.fullDescription;
                            this.selectedData.isTaxable = this.editForm.value.isTaxable;
                            this.selectedData.quantity = this.editForm.value.quantity;
                            this.setInventoryLineDataCustom(info);
                        }
                        this.afterSetInventoryLine();
                        let busObj: v_InventoryBus = info.primaryReturn as v_InventoryBus;
                        if (busObj.inventorySubCategoryId){
                            switch (busObj.inventorySubCategoryId.toLowerCase()) {
                                case CommonValues.InventorySubClass_Compressors.toLowerCase():
                                    this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Compressors.toLowerCase();
                                    break;
                                case CommonValues.InventorySubClass_Refrigerant.toLowerCase():
                                    this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Refrigerant.toLowerCase();
                                    break;
                                default:
                                    this.selectedData.supplierPartTypeMarkUpId = CommonValues.SupplierPartTypeMarkUp_Parts.toLowerCase();
                                    break;
                            }
                            if (this.supplierPartTypeMarkUp && this.supplierPartTypeMarkUp.length > 0) {
                                const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === this.selectedData.supplierPartTypeMarkUpId);
                                if (supplierPartTypeMarkUp) {
                                    this.selectedData.supplierPartTypeMarkUpString = supplierPartTypeMarkUp.partType;
                                    this.editForm.patchValue({
                                        supplierPartTypeMarkUpString: this.selectedData.supplierPartTypeMarkUpString,
                                        supplierPartTypeMarkUpId: this.selectedData.supplierPartTypeMarkUpId
                                    });
                                }
                            }
                        }
                        this.selectedData.resource = this.personName(this.selectedData.personId);
                        this.selectedData.calculateTotals();
                        if (!this.editForm) {
                            this.createForm();
                        }
                        this.setForm();
                        this.afterSetInventoryLineAfterSetForm();
                        this.inventorySearching = false;
                        this.sumGrid(this.selectedData);
                        this.setDirty();
                        this.dataLoading = false;
                    },
                error: (error) => {
                    this.inventorySearching = false;
                    console.error(error);
                    this.globals.notifyError(`Error getting inventory line. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                }
            });
    }

    onBlur(event, dataItem: v_QuoteInvoiceBus, editForm: UntypedFormGroup, field: string) {
        var mFactor = 1;
        if (field == "supplierPrice") {
            var supplierPartTypeMarkUpId = editForm.get("supplierPartTypeMarkUpId").value;
            const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
            if (supplierPartTypeMarkUp) {
                mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
            }
        }
        if (field == "supplierPriceR") {
            dataItem.amount = 0;
        }
        if (!this.parentObj) {
            return;
        }
        let isAdded = !CommonFunctions.hasValue(dataItem.hasId);
        let callSetTax: boolean = false;
        if (editForm.get("changeCodeId") && !isAdded && this.hasFeatureFlag('ui-change-reason-code-feature-not-requiring-reason-for-updates-after-initial-save-of-reason') && !this.selectedData.isAdded) {
            if (editForm.get(field).value !== dataItem[field]) {

                editForm.patchValue({
                    changeCodeId: null
                });
            }
        }
        if (editForm.get(field).value !== dataItem[field] || isAdded || field == 'isTaxable' || (this.hasFeatureFlag("billing-code-reset-invline") && !isAdded && editForm.get("inventoryBillingCodeId").value !== dataItem["inventoryBillingCodeId"])) {
            var val = editForm.get(field).value;
            var vals = editForm.value;
            dataItem[field] = val;
            if (field == 'quantity') {
                let totalCost: number = vals.quantity * CommonFunctions.Round(vals.cost);
                totalCost = CommonFunctions.RoundToPrecision(totalCost, 2);
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * vals.price), 2);
                if (!this.taxCode.isRetailTax && vals.isTaxable) {
                    let tax: number = 0;
                    let taxRate: number = this.taxCode.taxRate;
                    tax = CommonFunctions.Round(totalCost * taxRate);
                    editForm.patchValue({
                        tax: tax
                    });
                    dataItem.tax = tax;
                }
                var supplierAmount = 0;
                if (vals.supplierPrice && val) {
                    supplierAmount = val * vals.supplierPrice;
                }
                editForm.patchValue({
                    amount: amt,
                    totalCost: totalCost,
                    supplierAmount: supplierAmount
                });


                dataItem.supplierAmount = supplierAmount;
                dataItem.amount = amt;
                dataItem.totalCost = totalCost;
                callSetTax = true;
                if (vals.isPart && !dataItem.isConsumable && !dataItem.isTool) {
                    this.partQuantityChanged(vals.quantity, vals.originalQuantity);
                }
            }
            else if (field == 'cost') {
                let cost: number = CommonFunctions.RoundToPrecision(vals.cost, 3);
                let totalCost: number = CommonFunctions.RoundToPrecision((vals.quantity * cost), 2);
                if (!this.taxCode.isRetailTax && vals.isTaxable) {
                    let tax: number = CommonFunctions.Round(totalCost * this.taxCode.taxRate);
                    editForm.patchValue({
                        tax: tax
                    });
                    dataItem.tax = tax;
                    if (!vals.isPart) {
                        let muCost: number = CommonFunctions.Round(cost + (cost * this.taxCode.taxRate));
                        editForm.patchValue({
                            markupCost: muCost
                        });
                        dataItem.markupCost = muCost;
                    }
                }

                editForm.patchValue({
                    cost: cost,
                    totalCost: totalCost,
                });
                dataItem.cost = cost;
                dataItem.totalCost = totalCost;
                callSetTax = true;

                if (vals.inventoryBillingCodeId == CommonValues.BillingCode_MMAT) {
                    this.setRowFromCostAndPriceRange(vals, editForm, dataItem);
                }

            }
            else if (field == "markupCost") {
                if (vals.inventoryBillingCodeId == CommonValues.BillingCode_MMAT) {
                    this.setMarkupPercentFromMUCostChange(vals.markupCost, editForm, dataItem);
                } else {
                    if (!vals.isPart && !vals.isNonInvPart) {
                        let markup: number = vals.markupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                        editForm.patchValue({
                            markup: markup
                            , markupPercent: markup * 100
                        });
                        dataItem.markup = markup;
                    }
                    else {
                        if (CommonFunctions.hasArrayElementValue(this.customPricing.pricingRanges)) {
                            let markup: number = CommonFunctions.CalculateMarkup(vals.cost, this.customPricing.pricingRanges);
                            markup = CommonFunctions.RoundToPrecision(markup, 4);
                            let price: number = vals.markupCost * (markup + 1);
                            price = CommonFunctions.RoundToPrecision(price, 2);
                            let amount: number = CommonFunctions.RoundToPrecision(vals.quantity * price, 2);
                            editForm.patchValue({
                                markup: markup
                                , markupPercent: markup * 100
                                , price: price
                                , amount: amount
                            });
                            dataItem.markup = markup;
                            dataItem.price = price;
                            dataItem.amount = amount;
                        }
                    }
                }
            }
            else if (field == "markupPercent") {
                vals.markup = vals.markupPercent / 100;
                let calcMarkUp = CommonFunctions.RoundToPrecision(vals.markup, 4);
                let price: number = CommonFunctions.RoundToPrecision((vals.markupCost * (vals.markup + 1)), 2);
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * price), 2);
                editForm.patchValue({
                    price: price
                    , amount: amt
                });
                dataItem.price = price;
                dataItem.amount = amt;
                editForm.patchValue({
                    markup: calcMarkUp
                });
            }
            else if (field == "price") {
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * vals.price), 2);
                let markup: number = vals.markupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                markup = CommonFunctions.RoundToPrecision(markup, 4);
                editForm.patchValue({
                    amount: amt
                    , markupPercent: markup * 100
                    , markup: markup
                });
                dataItem.amount = amt;
                dataItem.markup = markup;
                if (vals.price == 0) {
                    editForm.patchValue({
                        isPrintable: false
                    });
                }
            }

            else if ((field == "supplierPrice" || field == "supplierPriceR") && this.editForm.get("supplierPrice").value > 0 && this.selectedData.supplierPrice != this.editForm.get("supplierPrice").value) {
                var val = this.editForm.get("supplierPrice").value;
                var supplierPartTypeMarkUpId = this.editForm.get("supplierPartTypeMarkUpId").value;
                var mFactor = 1;
                const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
                if (supplierPartTypeMarkUp) {
                    mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
                }
                var tCost = val * mFactor;
                var quantity = this.editForm.get("quantity").value
                var supplierAmount = val * quantity;
                editForm.patchValue({
                    cost: tCost,
                    supplierAmount: supplierAmount,
                    totalCost: tCost * quantity
                });
                dataItem.supplierAmount = supplierAmount;
                dataItem.totalCost = tCost * quantity;
                dataItem.cost = tCost;
                let tPrice = CommonFunctions.RoundToPrecision((1+vals.markup) * tCost, 2);
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * tPrice), 2);

                editForm.patchValue({
                    amount: amt,
                    price: tPrice,
                    markupCost: tCost
                });
                dataItem.markupCost = tCost;
                dataItem.amount = amt;
                dataItem.price = tPrice;
            }



            else if (field == "amount") {
                let price: number = vals.quantity != 0 ? vals.amount / vals.quantity : 0;
                price = CommonFunctions.RoundToPrecision(price, 2);
                let markup: number = vals.macrkupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                markup = CommonFunctions.RoundToPrecision(markup, 4);
                editForm.patchValue({
                    price: price
                    , markup: markup
                });
                dataItem.price = price;
                dataItem.markup = markup;
            }
            if (!isAdded) {
                dataItem.calculateTotals();
            }
            let paramDataItem: v_QuoteInvoiceBus = isAdded ? dataItem : null;
            paramDataItem = dataItem;
            this.sumGrid(paramDataItem); //dataItem.hasId ? null : dataItem);
        }
    }

    public recalcSubtotal() {
        var totalSum = 0;
        this.gridData.sort((a, b) => a.sortOrder - b.sortOrder);
        for (let e of this.gridData) {
            if (e.inventoryBillingCodeId == CommonValues.BillingCode_SubTotal) {

                if ((totalSum != e.amount)) {
                    e.price = totalSum;
                    e.amount = totalSum;
                    e.isUpdated = true;
                }
                totalSum = 0;
            }
            else {
                //priceSum = priceSum + e.price;
                totalSum = totalSum + e.amount;
            }
        };
    }

    setMarkupPercentFromMUCostChange(vals: any, editForm: any, dataItem: any) {
        let muCost = vals;
        let markDec = this.findPricingRangeMarkup(vals);

        let markPer = markDec * 100;
        let price = CommonFunctions.RoundToPrecision((muCost * (markDec + 1)), 2);
        let amt: number = CommonFunctions.RoundToPrecision((dataItem.quantity * price), 2);

        dataItem.price = price;
        dataItem.amount = amt;
        dataItem.markupPercent = markPer;

        editForm.patchValue({
            amount: amt,
            markupPercent: markPer,
            price: price
        });
    }

    setRowFromCostAndPriceRange(vals: any, editForm: any ,dataItem: any) {
        let cost = CommonFunctions.RoundToPrecision(vals.cost, 3);
        let markDec = this.findPricingRangeMarkup(cost);

        let markPer = markDec * 100;
        vals.markup = markPer / 100;

        let calcMarkUp = CommonFunctions.RoundToPrecision(vals.markup, 4);
        let price = CommonFunctions.RoundToPrecision((cost * (vals.markup + 1)), 2);
        let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * price), 2);

        dataItem.price = price;
        dataItem.amount = amt;
        dataItem.markupPercent = markPer;
        dataItem.markup = calcMarkUp;

        editForm.patchValue({
            markupCost: cost,
            amount: amt,
            markupPercent: markPer,
            markup: calcMarkUp,
            price: price
        });
    }

    setForm() {
        this.editForm?.patchValue({
            quoteInvoiceId: this.selectedData.quoteInvoiceId,
            sortOrder: this.selectedData.sortOrder,
            quantity: this.selectedData.quantity,
            cost: this.selectedData.cost,
            markup: this.selectedData.markup,
            markupPercent: this.selectedData.markup * 100,
            price: this.selectedData.price,
            isTaxable: this.selectedData.isTaxable,
            isPrintable: this.selectedData.isPrintable,
            quoteInvoiceDesc: this.selectedData.quoteInvoiceDesc,
            inventoryNumber: this.selectedData.inventoryNumber,
            isPart: this.selectedData.isPart,
            hourlyRate: this.selectedData.hourlyRate,
            overheadRate: this.selectedData.overheadRate,
            overheadPercent: this.selectedData.overheadPercent,
            amount: this.selectedData.amount,
            markupCost: this.selectedData.markupCost,
            fullDescription: this.selectedData.fullDescription,
            tax: this.selectedData.tax,
            quoteId: this.selectedData.quoteId,
            inventoryBillingCodeId: this.selectedData.inventoryBillingCodeId,
            inventoryLocationId: this.selectedData.inventoryLocationId,
            billingTypeId: this.selectedData.billingTypeId,
            personId: this.selectedData.personId,
            resource: this.selectedData.resource,
            warehouse: this.selectedData.warehouse,
            totalCost: this.selectedData.totalCost,
            isLabor: this.selectedData.isLabor,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            avalaraTaxCalculated: this.selectedData.avalaraTaxCalculated,
            allQuantity: this.selectedData.allQuantity,
            locationQuantity: this.selectedData.locationQuantity,
            supplierPrice: this.selectedData.supplierPrice,
            supplierAmount: this.selectedData.supplierAmount,
            supplierPartTypeMarkUpId: this.selectedData.supplierPartTypeMarkUpId,
            supplierPartTypeMarkUpString: this.selectedData.supplierPartTypeMarkUpString,

        });
    }
    supplierPartTypeMarkUpCBOChanged(e: any, dataItem: v_QuoteInvoiceBus) {
        if (!this.editForm.get("supplierPrice").value || !this.editForm.get("quantity").value  ) { return; }
        var val = this.editForm.get("supplierPrice").value;
        var supplierPartTypeMarkUpId = e.supplierPartTypeMarkUpId;
        var mFactor = 1;
        const supplierPartTypeMarkUp = this.supplierPartTypeMarkUp.find(user => user.supplierPartTypeMarkUpId === supplierPartTypeMarkUpId);
        if (supplierPartTypeMarkUp) {
            mFactor = mFactor + (supplierPartTypeMarkUp.markUp / 100)
        }
        var tCost = val * mFactor;
        var quantity = this.editForm.get("quantity").value
        var markup = this.editForm.get("markup").value
        var supplierAmount = val * quantity;
        this.editForm.patchValue({
            cost: tCost,
            supplierAmount: supplierAmount,
            totalCost: tCost * quantity,
            supplierPartTypeMarkUpString: e.partType
        });
        dataItem.supplierAmount = supplierAmount;
        dataItem.totalCost = tCost * quantity;
        let tPrice = CommonFunctions.RoundToPrecision((1 + markup) * tCost, 2);
        let amt: number = CommonFunctions.RoundToPrecision((quantity * tPrice), 2);

        this.editForm.patchValue({
            amount: amt,
            price: tPrice,
            markupCost: tCost
        });
        dataItem.markupCost = tCost;
        dataItem.amount = amt;
        dataItem.price = tPrice;

    }
    public setSupplier(id: string) {
        if (id) {
            this._vendorService.getSupplierPartTypeMarkUps(id).subscribe((data: any) => {

                this.supplierPartTypeMarkUp = data;

            });
        }
    }
    setFromReferenceData(data: v_QuoteInvoiceBus) {
        data.resource = this.personName(data.personId);
        return data;
    }
    invLocCBOChanged(e: any) {
        this.editForm.patchValue({
            warehouseId: e.value,
            warehouse: e.description,

        });

    }
    setQuantityInStockDetailAll(item: any) {
        if (!item) {
            item = { localQuantity: null, allQuantity: null }
        }
        this.editForm.patchValue({
            locationQuantity: item.localQuantity,
            allQuantity: item.allQuantity,
        });

    }
    public getChanged(): any {
        let arr = super.getChanged().sort((a, b) => (a.sortOrder * 1 > b.sortOrder * 1) ? 1 : -1);
        return arr;
    }
    protected getChangedObject(data: v_QuoteInvoiceBus) {
        let busObj: QuoteInvoiceBus = new QuoteInvoiceBus(data);
       // busObj.markup = this.editForm.value.markup / 100;
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }

    protected save(data: v_QuoteInvoiceBus) {
        let busObj: QuoteInvoiceBus = this.getChangedObject(data);
        //this.editForm.patchValue({
        //    markup: this.editForm.value.markup / 100
        //});
        //let busObj: QuoteInvoiceBus = new QuoteInvoiceBus(data);
        //busObj.markup = this.editForm.value.markup / 100;
        //busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        //busObj.setParentId(this._parentId);
            this.svc_data.saveQuoteInvoice(busObj).subscribe(data => {
                if (data != null) {
                    let dataObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(data);
                    this.saveSuccess(dataObj);
                }
                else {
                    this.saveError(data, "Error Saving");
                }
            });

    }
    public calcTotals() {
        this.reOrder();
        this.setTax();
        this.sumGrid();
    }
    deleteIndividual(data: v_QuoteInvoiceBus) {
        if (data.hasId) {
            this.svc_data.deleteQuoteInvoice(data.quoteInvoiceId).subscribe((dataObj: BaseMessageInfo) => {
                if (!dataObj.saveError) {
                    let delDataObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(data);

                    this.deleteSuccess(delDataObj);
                    this.removeLocal(delDataObj);
                }
                else {
                    this.deleteError(data, dataObj.message);

                }
            });
        }
        else {
            this.closeEditor();
        }
    }
    AfterLoad(): void {
        this.dataStateChange(null);
    }
    processGridData() {
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {

                this.gridData[i].resource = this.personName(this.gridData[i].personId);
                this.gridData[i].warehouse = this.warehouseName(this.gridData[i].inventoryLocationId);

            }
        }
        this.AfterLoad();
    }
    dataStateChange(e: any): void {
        //this.state = state;
        //this.gridDataDD = process(this.gridData, this.state);
        if (this.currentSubscription) {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }

        this.zone.onStable.pipe(take(1))
            .subscribe(() => this.currentSubscription = this.handleDragAndDrop());

    }
    popupDispatch() {

        this.showDispatch.emit(null);
    }
    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                dragging: context.dataItem.dragging,
                isDraged: context.dataItem.isDraged
            };
        return {};
    }
    setInventoryLineDataCustom(info: InvoiceMessageInfo) {
        this.selectedData.quoteInvoiceDesc = this.editForm.value.quoteInvoiceDesc;
    }

    ngOnDestroy(): void {
        CommonFunctions.unsubscribe(this.currentSubscription);
    }
    handleDragAndDrop(): Subscription {

        const sub = new Subscription(() => { });

        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        let droplocation;
        var dataItem;
        let overCnt: number = 0;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.quoteGridDiv > .k-grid tr'));
        tableRows.forEach(itemRow => {
            var item = itemRow.children[0];
            if (item.localName == 'td' && item.childNodes.length > 2) {
                this.renderer.setAttribute(itemRow, 'draggable', inEditMode);
                const dragStart = fromEvent<DragEvent>(itemRow, 'dragstart');
                const dragOver = fromEvent(itemRow, 'dragover');
                const dragEnd = fromEvent(itemRow, 'dragend');
                const dragLeave = fromEvent(itemRow, 'dragleave');

                sub.add(dragStart.pipe(
                    tap(({ dataTransfer }) => {
                        try {
                        } catch (err) {
                            // IE doesn't support setDragImage
                        }
                        try {
                            // Firefox won't drag without setting data
                        } catch (err) {
                            // IE doesn't support MIME types in setData
                        }
                    })
                ).pipe(takeUntil(this.destroy$)).subscribe(({ target }) => {
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                    //cell.parentElement;
                    //draggedItemIndex = row.rowIndex;
                    //const dataItem = this.gridData[draggedItemIndex];

                    draggedItemIndex = row.rowIndex;
                    var data = _.cloneDeep(this.grid.data);
                    dataItem = data.data[draggedItemIndex];

                }));
                sub.add(dragLeave.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {

                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    const dropIndex = this.closest(cell, this.tableRow).rowIndex;
                    if (remoteDropItemIndex == dropIndex) {
                        remoteDropItemIndex = null;
                        this.rowLine = null;
                    }
                    if (dropItemIndex == dropIndex) { dropItemIndex = null; }

                    if (row.localName == "tr") { row.classList.remove("drover") }

                }));

                sub.add(dragOver.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    if (draggedItemIndex >= 0) {
                        if (row.localName == "tr") { row.classList.add("drover") }
                    }
                    if (!draggedItemIndex) {
                    }
                    const dropIndex = this.closest(cell, this.tableRow).rowIndex;
                    dropItemIndex = dropIndex;
                    remoteDropItemIndex = dropIndex;
                    this.rowLine = dropIndex;
                    if (draggedItemIndex >= -1 && this.gridData.length + 1 >= draggedItemIndex) {
                        e.preventDefault();
                        const dataItem = this.gridData[draggedItemIndex];
                        dataItem.dragging = false;

                    }
                }));

                sub.add(dragEnd.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                    if (typeof dropItemIndex != 'undefined' && dropItemIndex != null) {
                        const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                        const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                        if (cell.localName == "tr") { cell.classList.remove("drover"); cell.classList.add('testclass'); }

                        e.preventDefault();
                        const dataItem = this.gridData.splice(draggedItemIndex, 1)[0];
                        this.zone.run(() => {
                            if (draggedItemIndex < dropItemIndex) {
                                dropItemIndex = dropItemIndex - 1;
                            }
                            this.gridData.splice( dropItemIndex, 0, dataItem )
                        });
                        draggedItemIndex = -1;
                        dataItem.dragging = false;

                        this.dataStateChange(null);
                        this.redoSortOrder();
                        // this.grid.data = this.gridData;
                    }
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;

                    if (cell.localName == "tr") { cell.classList.remove("drover"); row.classList.remove("drover"); }
                    if (row.localName == "tr") { row.classList.remove("drover"); }

                    else {
                        e.preventDefault();
                        var event = _.cloneDeep(dataItem);
                        event.detailType = 5;
                        event.detailSource = "Q";
                        event.dropid = event.quoteInvoiceId;

                        this.dropEvent.emit(event);

                    }
                    const tableRows = Array.from(document.querySelectorAll('div.invoiceGridDiv > .k-grid tr'));
                    tableRows.forEach(itemRow => {
                        itemRow.classList.remove("drover");
                    });

                }));
            }
        });

        return sub;
    }
    insertRow() {
        if (this.insertMode) return false;
        if (this.rowLine >= 0) {
            var inrow = new v_QuoteInvoiceBus();
            this.insertMode = true;
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 0, inrow);

            }
            );
            //   this.rowLine = null;
            //this.dataStateChange(null);
            //this.redoSortOrder();
            //this.redoSortOrder();
        }

        return true;

    }
    updateRow(dataItem: v_QuoteInvoiceBus) {

        if (this.rowLine >= 0) {
            var inrow = new v_QuoteInvoiceBus(dataItem);
            inrow.isDraged = true;
            inrow.quoteId = this.parentId;
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 1, inrow);
            }
            );
            this.rowLine = null;
            this.dataStateChange(null);
            this.redoSortOrder();
            this.insertMode = false;
            //this.redoSortOrder();
        }
    }
    public canDrop() {

        if (this.rowLine) { return true }
        if (this.rowLine == 0) { return true }
        return false;

    }
    redoSortOrder() {
        let sort: number = 1;
        this.zone.run(() => {
            for (let e of this.gridData) {
                e.sortOrder = sort++;
                e.isUpdated = true;
            }
        });
        this.recalcSubtotal();
        this.sumGrid();
    }
    protected saveLocal(data: v_QuoteInvoiceBus, isNew: boolean) {
        super.saveLocal(data, isNew);

        this.recalcSubtotal();
    }

    tableRow = node => node.tagName.toLowerCase() === 'tr';
    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };


    afterDelete(){
        super.afterDelete();
        if(this.featureFlagSet["ui-enable-lineitems-required-for-quote-save"]) {
            this.gridDataPopulateEvent.emit(this.hasGridData);
        }
    }
    partLocations: InventoryLocationXrefBus[];
    partLocationsActive: boolean = false;
    partLocationsHeight: number = 0;
    closePartLocations() {
        this.partLocationsActive = false;
    }
    showMainOnly: boolean = true;
    showMainOnlyChanged(value) {
        this.showMainOnly = value;
        this.showInventoryLocations(this.selectedRowData);
    }
    showInventoryLocations(dataItem: v_QuoteInvoiceBus) {
        this.selectedRowData = _.cloneDeep(dataItem);
        this.svc_inv.getCPInventoryLocationXref(dataItem.inventoryBillingCodeId).subscribe((data: any) => {
            next: {
                if (CommonFunctions.hasArrayValue(data.result)) {
                    if (data.result.length > 20) {
                        this.partLocationsHeight = 600;
                    }
                    else {
                        this.partLocationsHeight = 0;
                    }
                }

                let arr = [];
                if (CommonFunctions.hasArrayValue(data.result)) {
                    for (let i = 0; i < data.result.length; i++) {
                        let newObj: InventoryLocationXrefBus = new InventoryLocationXrefBus(data.result[i]);
                        newObj.warehouse = this.referenceData.getCpWarehouse(newObj.inventoryLocationId);
                        if (newObj.quantity > 0 && (!((newObj.warehouse ?? "") == "Staging Warehouse")) && ((!this.showMainOnly) || (newObj.warehouse ?? "").toUpperCase().includes("MAIN"))) {
                            arr.push(newObj);
                        }
                    }
                }
                arr.sort((a, b) => (a.quantity < b.quantity) ? 1 : -1);

                this.partLocations = null;
                this.partLocations = _.cloneDeep(arr);
                this.partLocationsActive = true;
            }
            error: (err) => {
                this.globals.notifyError(`Error getting inventory data.`, true);

            }
        });
    }
    partSuppliers: InventorySuppliersBus[];
    partSuppliersActive: boolean = false;
    partSuppliersHeight: number = 0;
    closePartSupplier() {
        this.partSuppliersActive = false;
    }
    showInventorySuppliers(dataItem: v_QuoteInvoiceBus) {
        this.svc_inv.getInventorySuppliers(dataItem.inventoryBillingCodeId).subscribe((data: InventorySuppliersBus[]) => {
            if (CommonFunctions.hasArrayValue(data)) {
                if (data.length > 20) {
                    this.partSuppliersHeight = 600;
                }
                else {
                    this.partSuppliersHeight = 0;
                }
            }
            this.partSuppliers = _.cloneDeep(data);
            this.partSuppliersActive = true;
        });
    }
}
